// extracted by mini-css-extract-plugin
export var closeButton = "_j8-1";
export var closeX = "_j8-3";
export var container = "_j8-0";
export var image = "_j8-2";